// extracted by mini-css-extract-plugin
export var subtitle = "_bn-2";
export var title = "_bn-0";
export var titleNoWrap = "_bn-1";